import { ActivityType } from "../generated-graphql/graphql";

export const WaitForAllActivityTypes: ActivityType[] = [
  ActivityType.WaitForAllCnReports,
  ActivityType.WaitForAllCredentialReports,
  ActivityType.WaitForAllAltIdReports,
  ActivityType.WaitForAllStateReports,
  ActivityType.WaitForAllFd,
  ActivityType.WaitForAllLepc,
  ActivityType.WaitForCohorts,
];
